import { Typography } from '@mui/material';
import { useCoursesAlphabetical } from '../../../../hooks/useCourses';
import { Column, Row } from '../../../../components';
import '../../../../themes/tippy-rounded.css';
import CourseItem from './CourseItems';

const CourseList = () => {
  const courses = useCoursesAlphabetical();

  if (courses?.length === 0) {
    return (
      <Row style={{ justifyContent: 'center' }}>
        <Typography variant='p20SemiBold' color='secondary'>
          You haven't created any courses yet.
        </Typography>
      </Row>
    );
  }

  return (
    <Column style={{ rowGap: '10px' }}>
      {courses?.map(course => (
        <CourseItem key={course.courseId} course={course} />
      ))}
    </Column>
  );
};

export default CourseList;
